import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class DateValidationService {

  constructor() {}

  addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  addYears(date: Date, years: number): Date {
    const result = new Date(date);
    result.setFullYear(result.getFullYear() + years);
    return result;
  }

  scheduleValidator(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const scheduleControl = formGroup.get('schedule');
      const drawDateControl = formGroup.get('drawDate');

      if (!scheduleControl || !drawDateControl) {
        return null;  // Ensure controls exist
      }

      const schedule = scheduleControl.value;
      const drawDate = drawDateControl.value;

      if (drawDateControl.hasError('required')) {
        // If the drawDate is required and not provided, show the required error
        return null;
      }

      if (schedule && drawDate) {
        const selectedDate = new Date(drawDate);
        const today = new Date();

        switch (schedule) {
          case 'daily':
            if (selectedDate > today) {
              drawDateControl.setErrors({ drawDateInvalid: 'Draw date cannot be more than today' });
              return { drawDateInvalid: 'Draw date cannot be more than today' };
            }
            break;
          case 'weekly':
            if (selectedDate > this.addDays(today, 7)) {
              drawDateControl.setErrors({ drawDateInvalid: 'Draw date can be set within 7 days from today' });
              return { drawDateInvalid: 'Draw date can be set within 7 days from today' };
            }
            break;
          case 'monthly':
            if (selectedDate > this.addDays(today, 30)) {
              drawDateControl.setErrors({ drawDateInvalid: 'Draw date can be set within 30 days from today' });
              return { drawDateInvalid: 'Draw date can be set within 30 days from today' };
            }
            break;
          case 'annually':
            if (selectedDate > this.addYears(today, 1)) {
              drawDateControl.setErrors({ drawDateInvalid: 'Draw date can be set within 1 year from today' });
              return { drawDateInvalid: 'Draw date can be set within 1 year from today' };
            }
            break;
          default:
            break;
        }
      }

      // Clear any existing errors if validation passes
      drawDateControl.setErrors(null);
      return null;
    };
  }
}
